/* ConditionalFormattingRenderer.js */

"use strict";
const _ = require("lodash");
const Sortable = require("sortablejs").default;
const ButtonControl = require("@gluenetworks/steve_ui_core").Control.Action.Button;
const moment = require("moment");
require("moment-duration-format");

const { CONDITIONAL_DATA } = require("./ConditionalDropdownData");
const colorsList = [
    // need to be 7chars #+hexcolor
    "#ff0000", //red
    "#d9534f", //d.red
    // "#f96b6b", //l.red
    "#00ff00", //green
    "#5cb85c", //d.green
    "#ffff00", //yellow
    "#ffa500", //orange
    "#29abe2", //blue
    "#cccccc", //l.grey
    "#4d4d4d", //d.grey
    "#1a1a1a" //v.d.grey
];
//expCondition --> expandedCondition

class ConditionalFormattingRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("conditional-formatting"); //TODO Setup the root Element
        this._rootElem.component = this._model;

        this._dataElem = document.createElement("div");
        this._dataElem.classList.add("data-element");

        this._cancelButton = new ButtonControl({
            label: "Cancel",
            darkTheme: true
        });

        this._saveButton = new ButtonControl({
            label: "OK",
            darkTheme: true,
            theme: this._model._isOwnUser ? "additive" : "",
            disabled: false
        });

        this._slickTableContainer = undefined;
        this._slickTable = undefined;

        this._titleComponent = document.createElement("h2");
        this._titleComponent.innerText = this._model.titleText;

        this._errorBox = document.createElement("span");
        this._errorBox.classList.add("hidden", "error");

        this._buttonContainer = document.createElement("button-container");

        /* Colorpicker colors datalist */
        this._colorPickerColorList = document.createElement("datalist");
        this._colorPickerColorList.setAttribute("id", "cp-colors-list");
        this._colorPickerColorList.innerHTML = colorsList.reduce((options, color) => {
            return (options += `<option>${color}</option>`);
        }, "");

        this._registerListeners();
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/

    _registerListeners() {
        this._cancelButton.on("UserClick", (this._onCancelButtonClick = this._onCancelButtonClick.bind(this)));
        this._saveButton.on("UserClick", (this._onSaveButtonClick = this._onSaveButtonClick.bind(this)));
        this._model.on("error", (this._onError = this._onError.bind(this)));
    }

    _unregisterListeners() {
        this._cancelButton.removeAllListeners("UserClick");
        this._saveButton.removeAllListeners("UserClick");
        this._model.removeAllListeners("error");
    }

    _onError(error) {
        this._errorBox.innerHTML = error;
        this._errorBox.classList.remove("hidden");
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/

    shutdown() {
        this._unregisterListeners();
        let promArr = [this._cancelButton.shutdown(), this._saveButton.shutdown()];

        return Promise.all(promArr).then(
            () => {
                this._cancelButton = undefined;
                this._saveButton = undefined;
                this._buttonContainer.remove();
                this._buttonContainer = undefined;
                this._errorBox.remove();
                this._errorBox = undefined;
                this._titleComponent.remove();
                this._titleComponent = undefined;
                this._model = undefined;
                this._rootElem.remove();
                this._rootElem = undefined;
            },
            (err) => {
                this._model.logger.warn(err, "CreateQuestionRenderer.shutdown() error");
            }
        );
    }

    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        return new Promise((resolve /*,reject*/) => {
            if (!this._rootElem.hasChildNodes()) {
                this._rootElem.appendChild(this._dataElem);
                this._dataElem.appendChild(this._titleComponent);
                this._createForm();
                this._rootElem.appendChild(this._errorBox);
                this._rootElem.appendChild(this._buttonContainer);
                this._buttonContainer.appendChild(this._cancelButton.renderer.rootElement);
                this._buttonContainer.appendChild(this._saveButton.renderer.rootElement);
                this._rootElem.appendChild(this._colorPickerColorList);
                if (!this._model._isOwnUser) {
                    this._saveButton.setDisabled(true);
                }
                // else {
                //     this._toggleSave();
                // }
            }
            resolve();
        });
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    _createForm() {
        const parentContainer = document.createElement("div");
        parentContainer.classList.add("parent-container");

        const fieldNameContainer = this._createColumn();
        const fieldNameLabel = document.createElement("span");
        fieldNameLabel.classList.add("label-class");
        fieldNameLabel.innerText = "Field Name";
        this.fieldNameValue = document.createElement("span");
        this.fieldNameValue.innerText = this._model._fieldName.replace(/>/g, " > ");
        fieldNameContainer.appendChild(fieldNameLabel);
        fieldNameContainer.appendChild(this.fieldNameValue);

        const columnTitleContainer = document.createElement("div");
        const columnTitleLabel = document.createElement("span");
        columnTitleLabel.innerText = "Column Title";
        columnTitleLabel.classList.add("label-class");
        this.columnTitleValue = document.createElement("span");
        this.columnTitleValue.innerText = this._model._columnTitle;
        columnTitleContainer.appendChild(columnTitleLabel);
        columnTitleContainer.appendChild(this.columnTitleValue);

        const fieldTypeContainer = document.createElement("div");
        const fieldTypeLabel = document.createElement("span");
        fieldTypeLabel.innerText = "Field Type";
        fieldTypeLabel.classList.add("label-class");
        this.fieldTypeValue = document.createElement("span");
        this.fieldTypeValue.innerText = this._model._fieldType;
        fieldTypeContainer.appendChild(fieldTypeLabel);
        fieldTypeContainer.appendChild(this.fieldTypeValue);

        const leftContainer = this._createColumn();
        leftContainer.appendChild(columnTitleContainer);
        leftContainer.appendChild(fieldTypeContainer);

        // slickContainer.appendChild();

        parentContainer.appendChild(leftContainer);
        parentContainer.appendChild(fieldNameContainer);

        this._dataElem.appendChild(parentContainer);
        this.slickMainContainer = document.createElement("div");
        // slickMainContainer.classList.add("conditional-slick-container");
        this.slickMainContainer.classList.add("conditional-table-container");

        // this._slickTableContainer = document.createElement("slick-container");
        // slickMainContainer.appendChild(this._slickTableContainer);
        this._dataElem.appendChild(this.slickMainContainer);
        // this._createSlickGrid();

        this._createGridTable();

        this._dataElem.appendChild(this._createAddNew());

        this._makeSortable();
    }

    _createColumn() {
        const column = document.createElement("div");
        column.classList.add("col-50");
        return column;
    }

    _createGridTable() {
        let data = (this._model._conditionalData = this._model._currentItem.conditionalFormat || []);
        this.slickMainContainer.appendChild(this._generateHeaderRow());
        data.forEach((row) => {
            this._addRow(row);
        });
    }

    _addRow(row) {
        this.slickMainContainer.appendChild(this._generateTableRow(row));
    }

    _createAddNew() {
        const addNew = document.createElement("div");
        addNew.classList.add("add-new-item");

        const span = document.createElement("span");
        span.innerText = "+ Add rule";
        if (this._model._isOwnUser) {
            span.addEventListener("click", (this._onAddNewRow = this._onAddNewRow.bind(this)));
        } else {
            addNew.classList.add("disabled");
        }

        addNew.appendChild(span);
        return addNew;
    }

    _generateHeaderRow() {
        const mainRowContainer = document.createElement("div");
        mainRowContainer.classList.add("row", "header");

        /* Reorder Block : Start */
        const colSort = document.createElement("div");
        colSort.classList.add("col-reorder", "header");
        /* Reorder Block : End */

        /* Rule Block : Start */
        const colRule = document.createElement("div");
        colRule.classList.add("col-rule", "header");
        colRule.innerText = "Highlight if...";
        /* Rule Block : End */

        /* Color Picker Block : Start */
        const colColPicker = document.createElement("div");
        colColPicker.classList.add("col-colPick", "header");
        colColPicker.innerText = "Highlight Color";
        /* Color Picker Block : End */

        /* Stop if true : Start */
        const colStopIfTrue = document.createElement("div");
        colStopIfTrue.classList.add("col-stopIfTrue", "header");
        colStopIfTrue.innerText = "Stop if true";
        /* Stop if true : End */

        /* Delete Row Block : Start */
        const colDelete = document.createElement("div");
        colDelete.classList.add("col-delete", "header");
        /* Delete Row Block : End */

        mainRowContainer.appendChild(colSort);
        mainRowContainer.appendChild(colRule);
        mainRowContainer.appendChild(colColPicker);
        mainRowContainer.appendChild(colStopIfTrue);
        mainRowContainer.appendChild(colDelete);

        return mainRowContainer;
    }

    _generateTableRow(row) {
        const mainRowContainer = document.createElement("div");
        mainRowContainer.classList.add("row");
        mainRowContainer.setAttribute("row-id", this._model._rowIndex);
        this._model._rowIndex++;

        /* Reorder Block : Start */
        const colSort = document.createElement("div");
        colSort.classList.add("col-reorder", "g-icon-drag");
        /* Reorder Block : End */

        /* Rule Block : Start */
        const colRule = document.createElement("div");
        colRule.classList.add("col-rule");
        let inpt = document.createElement("select");
        inpt.classList.add("condition-selector");
        inpt.setAttribute("data-type", this._model._fieldType);
        if (!this._model._isOwnUser) {
            inpt.disabled = true;
        }
        inpt = this._createOption(inpt, this._model._fieldType);
        // inpt.selectedOptions
        colRule.appendChild(inpt);
        inpt.addEventListener("change", (e) => {
            this._setItem(e.target.parentElement.parentElement.getAttribute("row-id"), "operator", e.target.value);
            this._createSecondLevelFields(e.target);
        });
        inpt.value = _.get(row.condition, "operator", "equal");
        /* Rule Block : End */

        /* Color Picker Block : Start */
        const colColPicker = document.createElement("div");
        colColPicker.classList.add("col-colPick");
        const inptColPick = document.createElement("input");
        inptColPick.setAttribute("type", "color");
        if (!this._model._isOwnUser) {
            inptColPick.disabled = true;
        }
        inptColPick.setAttribute("list", "cp-colors-list");
        inptColPick.addEventListener("change", (this._highlightColorChange = this._highlightColorChange.bind(this)), false);

        inptColPick.value = row.highlightColor;

        colColPicker.appendChild(inptColPick);
        /* Color Picker Block : End */

        /* Stop if true : Start */
        const colStopIfTrue = document.createElement("div");
        colStopIfTrue.classList.add("col-stopIfTrue");
        const inptStopIfTrue = document.createElement("input");
        inptStopIfTrue.setAttribute("type", "checkbox");
        if (!this._model._isOwnUser) {
            inptStopIfTrue.disabled = true;
        }
        inptStopIfTrue.addEventListener("change", (this._stopIfTrueChange = this._stopIfTrueChange.bind(this)), false);

        inptStopIfTrue.checked = row.stopIfTrue;

        colStopIfTrue.appendChild(inptStopIfTrue);
        /* Stop if true : End */

        /* Delete Row Block : Start */
        const colDelete = document.createElement("div");
        colDelete.classList.add("col-delete");
        const _deleteIcon = document.createElement("actionable-icon-gl");
        if (!this._model._isOwnUser) {
            _deleteIcon.disabled = true;
        }
        _deleteIcon.dataset.icon = "common.trash_bin";
        _deleteIcon.setAttribute("title", "Delete Row");
        _deleteIcon.addEventListener("click", (this._deleteClick = this._deleteClick.bind(this)), false);
        colDelete.appendChild(_deleteIcon);
        /* Delete Row Block : End */

        mainRowContainer.appendChild(colSort);
        mainRowContainer.appendChild(colRule);
        mainRowContainer.appendChild(colColPicker);
        mainRowContainer.appendChild(colStopIfTrue);
        mainRowContainer.appendChild(colDelete);

        const e = new Event("change");
        inpt.dispatchEvent(e);

        return mainRowContainer;
    }

    // Enum : {dataType: "enum", rule: "eq", options}
    // Boolean : {dataType: "boolean", rule: "eq"}
    // Number : {dataType: "number", rule: "eq"}
    // String : {dataType: "string", rule: "eq"}
    _generateSlickRow(idx = 1) {
        if (idx === 0 || _.isEmpty(this._model._currentItem.conditionalFormat)) {
            this._model._conditionalData.push({
                condition: { operator: "equal" },
                highlightColor: "#4d4d4d",
                stopIfTrue: false
            });
        } else if (!_.isEmpty(this._model._currentItem.conditionalFormat)) {
            this._model._currentItem.conditionalFormat.forEach((item) =>
                item
                    ? this._model._conditionalData.push({
                          condition: {
                              operator: item.condition.operator,
                              val1: item.condition.val1 || "",
                              val2: item.condition.val2 || ""
                          },
                          highlightColor: item.highlightColor || "#4d4d4d",
                          stopIfTrue: item.stopIfTrue
                          // condition: item.condition
                      })
                    : false
            );
        }

        return this._model._conditionalData;
    }

    _createOption(inpt, dataType) {
        const list = CONDITIONAL_DATA[dataType];

        Object.keys(list).forEach((item) => {
            const option = document.createElement("option");
            option.text = list[item].label;
            option.value = item;
            inpt.options.add(option);
        });

        return inpt;
    }

    _createSecondLevelFields(elem) {
        const dataType = elem.getAttribute("data-type"),
            operator = elem.value,
            targetField = CONDITIONAL_DATA[dataType][operator];
        const currentRow = this._model._conditionalData[elem.parentElement.parentElement.getAttribute("row-id")];

        this._createField(elem, targetField, currentRow.condition);
    }

    _createField(inpt, targetFieldObj, values = []) {
        const cell = inpt.parentElement,
            radioVal = _.get(values, "val1", "");
        const op = _.get(values, "operator", undefined);
        cell.querySelectorAll("input").forEach((inpt) => {
            inpt.remove();
        });
        cell.querySelectorAll("select[type='dropdown']").forEach((ddwn) => {
            ddwn.remove();
        });

        let _val;
        switch (targetFieldObj.type) {
            case "text":
                for (let i = 0; i < targetFieldObj.fields; i++) {
                    const field = document.createElement("input");
                    field.setAttribute("type", targetFieldObj.type);
                    field.setAttribute("field", i + 1);
                    if (!this._model._isOwnUser) {
                        field.disabled = true;
                    }
                    if (op === "in" || op === "not_in") {
                        field.setAttribute("placeholder", "Please enter comma seperated values.");
                    }
                    cell.appendChild(field);
                }
                cell.querySelectorAll("input").forEach((inpt, idx) => {
                    let _val = _.get(values, `val${idx + 1}`, "");
                    // if((op === "in" || op === "not_in") && _val) {
                    //     _val = _val.join(",");
                    // }
                    inpt.value = _val;
                    inpt.addEventListener("change", (this._onSecondLevelFieldValueChange = this._onSecondLevelFieldValueChange.bind(this)), false);
                });
                break;
            case "number":
            case "duration":
                for (let i = 0; i < targetFieldObj.fields; i++) {
                    const field = document.createElement("input");
                    field.setAttribute("type", targetFieldObj.type);
                    field.setAttribute("field", i + 1);
                    if (!this._model._isOwnUser) {
                        field.disabled = true;
                    }
                    cell.appendChild(field);
                }
                cell.querySelectorAll("input").forEach((inpt, idx) => {
                    _val = _.get(values, `val${idx + 1}`, "");
                    if (this._model._fieldType === "duration") {
                        _val = moment.duration(_val, "milliseconds").asHours();
                    }
                    inpt.value = _val;
                    inpt.addEventListener("change", (this._onSecondLevelFieldValueChange = this._onSecondLevelFieldValueChange.bind(this)), false);
                });
                break;
            case "date":
                for (let i = 0; i < targetFieldObj.fields; i++) {
                    const field = document.createElement("input");
                    field.setAttribute("type", "date");
                    field.setAttribute("field", i + 1);
                    if (!this._model._isOwnUser) {
                        field.disabled = true;
                    }
                    cell.appendChild(field);
                }
                cell.querySelectorAll("input").forEach((inpt, idx) => {
                    inpt.valueAsNumber = _.get(values, `val${idx + 1}`, "");
                    inpt.addEventListener("change", (this._onSecondLevelFieldValueChange = this._onSecondLevelFieldValueChange.bind(this)), false);
                });
                break;
            case "radio":
                for (let i = 0; i < targetFieldObj.fields; i++) {
                    const field = document.createElement("input"),
                        rowId = inpt.parentElement.parentElement.getAttribute("row-id");
                    field.setAttribute("type", targetFieldObj.type);

                    field.setAttribute("id", `${rowId}-${i}`);
                    field.setAttribute("field", "1");
                    field.setAttribute("name", rowId);
                    if (!this._model._isOwnUser) {
                        field.disabled = true;
                    }
                    const label = document.createElement("label");
                    label.setAttribute("for", `${rowId}-${i}`);

                    if (i === 0) {
                        field.value = "true";
                        label.innerText = "True";
                        field.checked = true;
                    } else {
                        field.value = "false";
                        label.innerText = "False";
                    }

                    cell.appendChild(field);
                    cell.appendChild(label);
                }

                cell.querySelectorAll("input").forEach((inpt, idx) => {
                    if (radioVal === "true" || (radioVal === true && idx === 0)) {
                        inpt.checked = true;
                    }

                    if ((radioVal === "false" || radioVal === false) && idx === 1) {
                        inpt.checked = true;
                    }

                    inpt.addEventListener(
                        "change",
                        (this._onSecondLevelRadioFieldValueChange = this._onSecondLevelRadioFieldValueChange.bind(this)),
                        false
                    );
                });
                break;
            case "dropdown":
                if (!_.isEmpty(values)) {
                    const field = document.createElement("select");
                    this._model._enumValues.forEach((item) => {
                        const option = document.createElement("option");
                        option.text = item.text;
                        option.value = item.value;
                        field.options.add(option);
                    });
                    field.setAttribute("field", "1");
                    field.setAttribute("type", targetFieldObj.type);
                    if (!this._model._isOwnUser) {
                        field.disabled = true;
                    }
                    cell.appendChild(field);
                    field.selectedIndex = "1";
                }
                cell.querySelectorAll("select[type='dropdown']").forEach((inpt, idx) => {
                    inpt.value = _.get(values, `val${idx + 1}`, "");
                    inpt.addEventListener("change", (this._onSecondLevelFieldValueChange = this._onSecondLevelFieldValueChange.bind(this)), false);
                });
                break;
            default:
                break;
        }
    }

    _makeSortable() {
        Sortable.create(this.slickMainContainer, {
            filter: ".header",
            handle: ".col-reorder",
            animation: 150,
            onEnd: (/**Event*/ evt) => {
                const arrSortOrder = [];
                evt.to
                    .querySelectorAll(".row")
                    .forEach((item) => (item.getAttribute("row-id") ? arrSortOrder.push(parseInt(item.getAttribute("row-id"))) : false));
                this.reorder(this._model._conditionalData, arrSortOrder, arrSortOrder.length);
                evt.to.querySelectorAll(".row").forEach((item, idx) => item.setAttribute("row-id", idx - 1));
            }
        });
    }

    reorder(arr, index, n) {
        let temp = [...Array(n)];

        // arr[i] should be present at index[i] index
        for (let i = 0; i < n; i++) {
            temp[index[i]] = arr[i];
        }

        // Copy temp[] to arr[]
        for (let i = 0; i < n; i++) {
            arr[i] = temp[i];
            index[i] = i;
        }
    }

    _setItem(rowId, col, val) {
        if (!this._model._conditionalData[rowId].condition) {
            this._model._conditionalData[rowId].condition = {};
        }
        let _val;
        switch (col) {
            case "operator":
                this._model._conditionalData[rowId].condition.operator = val;
                break;
            case "highlightColor":
                this._model._conditionalData[rowId].highlightColor = val;
                break;
            case "stopIfTrue":
                this._model._conditionalData[rowId].stopIfTrue = val;
                break;
            case "val1":
                _val = val;
                if (this._model._fieldType === "duration") {
                    _val = moment.duration(val, "hours").asMilliseconds();
                }
                // const op = this._model._conditionalData[rowId].condition.operator;
                // let _val = val;
                // if(op && _val && (op === "in" || op === "not_in")) {
                //     _val = _val.split(",");
                // }
                this._model._conditionalData[rowId].condition.val1 = _val;
                break;
            case "val2":
                _val = val;
                if (this._model._fieldType === "duration") {
                    _val = moment.duration(val, "hours").asMilliseconds();
                }
                this._model._conditionalData[rowId].condition.val2 = _val;
                break;
            default:
                break;
        }
    }

    /*******************************************/
    /* END COMPONENT RENDERER METHODS          */
    /* START PRIVATE RENDER METHODS            */
    /*******************************************/

    // TODO Private Render Methods here

    /*******************************************/
    /* END PRIVATE RENDER METHODS              */
    /* START HANDLER METHODS                   */
    /*******************************************/

    _onCancelButtonClick() {
        this.model.cancelAction();
    }

    _onSaveButtonClick() {
        // console.log("Save click");
        if (!this._validateInputs()) {
            // this._saveButton.setDisabled(true);
            return;
        }
        // if(_.isEqual(this._model._currentItem.conditionalFormat, this._model._conditionalData)) {
        //     console.log("equal");
        // }
        this._model._currentItem.conditionalFormat = this._model._conditionalData.length > 0 ? this._model._conditionalData : undefined;
        this._model.resolve();
    }

    _onUserValue(/*value*/) {
        // if(!_.isEmpty(value.trim())) {
        //     this._saveButton.setDisabled(false);
        // } else {
        //     this._saveButton.setDisabled(true);
        // }
    }

    _highlightColorChange(e) {
        this._setItem(e.target.parentElement.parentElement.getAttribute("row-id"), "highlightColor", e.target.value);
    }

    _onSecondLevelFieldValueChange(e) {
        this._setItem(
            e.target.parentElement.parentElement.getAttribute("row-id"),
            `val${e.target.getAttribute("field")}`,
            e.target.type === "date" || e.target.type === "number" ? e.target.valueAsNumber : e.target.value
        );
        this._toggleSave();
    }

    _onSecondLevelRadioFieldValueChange(e) {
        let radioValue = false;
        e.target.parentElement.querySelectorAll("input[type='radio']").forEach((e, idx) => {
            if (idx === 0 && e.checked === true) {
                radioValue = true;
            }
        });
        this._setItem(e.target.parentElement.parentElement.getAttribute("row-id"), "val1", radioValue);
        this._toggleSave();
    }

    _stopIfTrueChange(e) {
        this._setItem(e.target.parentElement.parentElement.getAttribute("row-id"), "stopIfTrue", e.target.checked);
    }

    _deleteClick(e) {
        const row = e.target.closest(".row"),
            rowId = e.target.closest(".row").getAttribute("row-id"),
            parentElmnt = row.parentElement;
        this._model._conditionalData.splice(rowId, 1);
        row.remove();
        parentElmnt.querySelectorAll(".row:not(.header)").forEach((item, idx) => {
            item.setAttribute("row-id", idx);
            this._model._rowIndex = idx;
        });
        this._toggleSave();
    }

    _onAddNewRow() {
        const data = this._generateSlickRow(0);
        this._addRow(data[0]);

        this._makeSortable();
        // this._saveButton.setDisabled(true);
    }

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE API METHODS               */
    /*******************************************/
    _validateInputs() {
        this._errorBox.classList.add("hidden");
        const inps = this._dataElem.querySelectorAll(".col-rule:not(.header)>*:not(.condition-selector):not(input[type=radio]):not(label)");
        const _invalidInps = Array.prototype.filter.call(inps, (inp) => {
            // if(inp.tagName === "LABEL") {
            //     return false;
            // }
            if (inp.value) {
                inp.classList.remove("error");
                return false;
            }
            inp.classList.add("error");
            return true;
        });
        const radioInps = this._dataElem.querySelectorAll(".col-rule:not(.header)>[data-type=boolean]");
        const _radioValid = Array.prototype.filter.call(radioInps, (el) => {
            const _parent = el.parentElement;
            const _radName = el.nextSibling.name;
            const _radVal = _parent.querySelector(`input[name='${_radName}']:checked`);
            if (_radVal) {
                _parent.classList.remove("error");
                return false;
            }
            _parent.classList.add("error");
            return true;
        });
        const invalidInps = [].concat(_invalidInps, _radioValid);
        if (invalidInps.length <= 0) {
            return true;
        }
        // this._model.emit("error", "Invalid inputs.");
        return false;
    }

    _toggleSave() {
        this._validateInputs();
        // this._saveButton.setDisabled(!this._validateInputs())
    }

    /*******************************************/
    /*  END PRIVATE API METHODS                */
    /*******************************************/
}

module.exports = ConditionalFormattingRenderer;
